import {AfterContentInit, Component, OnInit} from '@angular/core';
import {BaseComponent} from "../../base/base.component";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends BaseComponent implements OnInit, AfterContentInit {

  constructor(public router: Router,
              public translate: TranslateService) {
    super(router, translate)
  }

  ngOnInit(): void {
    // Retorno do logout (inclusive vindo do Azure AD): limpa AMBOS os storages
    // (token em sessionStorage; re/culture/employeeId/kaizen/role em localStorage). O template
    // exibe o link "Logar novamente" (/login).
    localStorage.clear();
    sessionStorage.clear();
  }

  ngAfterContentInit(): void {
    super.toggleLoader(false);
  }
}
